import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createWebhookRegistrationQuery } from '../apis';

const useCreateWebhookRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createWebhookRegistrationQuery,
    onSuccess: () => {
      toast.success('Webhook registration created successfully');
      queryClient.invalidateQueries({ queryKey: ['webhook-registration', 'list'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Failed to create webhook registration';
      toast.error(message);
    },
  });
};

export default useCreateWebhookRegistration;
